import { render } from "./PostingRecordsAllDiff.vue?vue&type=template&id=7171039d&scoped=true&ts=true"
import script from "./PostingRecordsAllDiff.vue?vue&type=script&lang=ts"
export * from "./PostingRecordsAllDiff.vue?vue&type=script&lang=ts"

import "./PostingRecordsAllDiff.vue?vue&type=style&index=0&id=7171039d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7171039d"]])

export default __exports__